import React from "react";

function About() {
  return (
    <div className="about-page">
      <h2>About Habit Tracker</h2>
      <p>
        We help you manage your habits in easy steps - no app download required!
        Simply track your daily activities, mark completion status, and build
        better habits right from your browser.
      </p>
      <p>
        Stay consistent, stay motivated, and watch your progress grow over time.
        Our simple interface makes habit tracking effortless and accessible
        anywhere, anytime.
      </p>
    </div>
  );
}

export default About;
